import React from "react";
import KotLogo from "../../Assets/InvoiceOrderlyLogo.png";
import style from "./Invoice.module.scss";

/**
 * Invoice component — renders a printable invoice for the current order.
 *
 * @param {Object}   props
 * @param {Object}   props.custDetails        Customer information
 * @param {string}   props.custDetails.name       Customer’s name
 * @param {string}   props.custDetails.phone      Customer’s phone number
 * @param {string}   props.custDetails.paymentType  Payment method selected
 * @param {Array<Object>} props.items             Array of item objects included in this invoice
 * @param {Object.<number, number>} props.itemQuantities  Map of item IDs to their quantities
 * @returns {JSX.Element} A formatted invoice ready for printing
 */
function Invoice({ custDetails, items, addedItemIds, itemQuantities, invoiceData }) {

  //Filtering seleced item in respective to all items
  const selectedItems = items.filter((item) => addedItemIds.includes(item._id));

  //Total quantity including allitems in cart
  const totalQuantity = selectedItems.reduce(
    (sum, item) => sum + (itemQuantities[item._id] || 0),
    0
  );

  //Total price including all the items
  const totalPrice = selectedItems.reduce(
    (sum, item) => sum + item.price * (itemQuantities[item._id] || 0),
    0
  );

  return (
    <div className={`${style.InvoiceComp}`} style={{ fontSize: "12px", width: "100%" }}>
      <div className="d-flex justify-content-center">
        <img src={KotLogo} height={40} width={90} alt="" />
      </div>
      <div className="d-flex justify-content-center flex-column text-center pb-2 orderlytext" >
        <span style={{ fontSize: "12px" }}>{process.env.REACT_APP_INVOICE_ADDRESS}</span>
        <span style={{ fontSize: "12px" }}>Phone: {process.env.REACT_APP_INVOICE_PHONE}</span>
      </div>
      <div className="d-flex flex-column pb-2 left-align">
        <span style={{ fontSize: "12px" }}>
          Bill No: {
            invoiceData?.data?.invoiceNumber ? (
              (() => {
                const invoiceNumber = invoiceData.data.invoiceNumber;
                const parts = invoiceNumber.split('-');
                if (parts.length >= 2) {
                  const prefix = parts.slice(0, -1).join('-');
                  const lastDigits = parts[parts.length - 1];
                  return (
                    <>
                      {prefix}-<strong style={{ fontSize: "16px" }}>{lastDigits}</strong>
                    </>
                  );
                }
                return invoiceNumber;
              })()
            ) : ""
          } {invoiceData?.data?.tableNumber && (
            <span style={{ fontSize: "12px" }}>Table: {invoiceData.data.tableNumber}</span>
          )}

        </span>
        <span style={{ fontSize: "12px" }}>
          Created On: {invoiceData?.data?.createdAt ? new Date(invoiceData.data.createdAt).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          }) + ' ' + new Date(invoiceData.data.createdAt).toLocaleTimeString('en-IN', {
            hour: '2-digit',
            minute: '2-digit'
          }) : ""}
        </span>
        <span style={{ fontSize: "12px" }}>
          Order Type: {invoiceData?.data?.orderType === "dine-in" ? "Dine-In" : "Take-Away"} | Customer: {process.env.REACT_APP_ADD_CUSTOMER === "true" ? custDetails.name : ''} | {invoiceData?.data?.mobileNumber?.length > 0 ? invoiceData.data.mobileNumber : "Cash"}
        </span>
        {/* <span style={{fontSize: "12px"}}>
          Table Number: {invoiceData?.data?.tableNumber || ""}
        </span> */}
        {/* <span style={{fontSize: "12px"}}>
          Customer: {custDetails.name} | {invoiceData?.data?.mobileNumber?.length > 0 ? invoiceData.data.mobileNumber : "Cash"}
        </span> */}
      </div>
      <table style={{ width: "100%", fontSize: "12px", tableLayout: "fixed" }}>
        <thead>
          <tr>
            <th style={{ textAlign: "left", fontSize: "12px", width: "50%" }}>Item Name</th>
            <th style={{ textAlign: "left", fontSize: "12px", width: "15%" }}>Qty</th>
            <th style={{ textAlign: "left", fontSize: "12px", width: "15%" }}>Rate</th>
            <th style={{ textAlign: "left", fontSize: "12px", width: "20%" }}>Total</th>
          </tr>
        </thead>
        <tbody style={{ fontSize: "12px" }}>
          {selectedItems.map((item) => (
            <tr key={item._id}>
              <td style={{ textAlign: "left", fontSize: "12px", width: "50%" }}>{item.name}</td>
              <td style={{ textAlign: "left", fontSize: "12px", width: "15%" }}>{itemQuantities[item._id]}</td>
              <td style={{ textAlign: "left", fontSize: "12px", width: "15%" }}>{item.price}</td>
              <td style={{ textAlign: "left", fontSize: "12px", width: "20%" }}>
                {item.price * itemQuantities[item._id]}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="d-flex flex-column pt-1 total-items">
        <span className="fw-bold boldcont" style={{ fontSize: "12px" }}>Total Items: {selectedItems.length}</span>
        <span className="fw-bold" style={{ fontSize: "12px" }}>Total Quantity: {totalQuantity}</span>
        <span className="d-flex w-100 fw-bold" style={{ fontSize: "12px" }}>
          <span style={{ minWidth: "60px" }}>Sub Total:</span>
          <span className="ms-auto me-3" style={{ whiteSpace: "nowrap" }}>
            ₹{totalPrice}
          </span>
        </span>
        <span className="d-flex justify-content-center text-center">
          <div className="total-price">
            <span style={{ fontSize: "14px" }} className="fw-bold ">
              Total ₹{totalPrice}
            </span>
          </div>

        </span>

        <div className="d-flex flex-column text-center thank-you">
          <span style={{ fontSize: "13px" }} className="fw-bold">
            Thank you, visit again!
          </span>
          <span style={{ fontSize: "10px" }}>
            Powered by {process.env.REACT_APP_PRODUCT_NAME}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Invoice;